import http from "../../../components/common/HttpCommon";

class UploadFilesService {
  upload(file, onUploadProgress) {
    let formData = new FormData();

    formData.append("file", file);

    return http.post("/thread/addfile", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }
}

const uploadFilesService = new UploadFilesService();
export default uploadFilesService;
